import { Alert, AlertTitle, Stack, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { AdminWorkflow } from "@/components/admin/workflow";
import { TabsComponent } from "@/components/core/tabs-component";

const tabs = ["workflows", "templates", "tags"] as const;

const schema = z.object({
  onboarding: z.string().uuid().optional(),
  tab: z.enum(tabs).default(tabs[0]),
});

export const Route = createFileRoute("/_authenticated/_contained/admin/workflows")({
  component: RouteComponent,
  validateSearch: schema,
});

function RouteComponent() {
  const { onboarding, tab } = Route.useSearch();
  const navigate = Route.useNavigate();

  const selectedTabIndex = Math.max(tabs.indexOf(tab), 0);
  const onTabChange = (index: number) => {
    navigate({ search: { tab: tabs[index], onboarding } });
  };

  const tab_obs = [
    {
      label: "Workflows",
      component: <AdminWorkflow />,
    },
  ];

  return (
    <Stack spacing={4}>
      <Typography variant="h3">Workflows</Typography>
      {onboarding && (
        <Alert severity="info">
          <AlertTitle>Clone an existing workflow</AlertTitle>
          Clone a workflow from an existing organization to add it to your new organization.
        </Alert>
      )}
      <TabsComponent selectedTab={selectedTabIndex} onSelectedTab={onTabChange} tabs={tab_obs} />
    </Stack>
  );
}
